import { Box } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { IconButton } from "screens/Root/components/IconButton";
import { useRootSelector } from "screens/Root/hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { toggleRightPanel } from "../../slices/rootSlice";
const ExpanderContainer = withStyles({
    root: {
        position: "absolute",
        top: "50%",
        left: 0,
        cursor: "pointer",
        backgroundColor: "white",
    },
})(Box);
const Expander = ({ dockedActive }) => {
    const dispatch = useDispatch();
    const expanderOnClick = () => dispatch(toggleRightPanel());
    const { rightPanelExpanded } = useRootSelector();
    const iconName = rightPanelExpanded ? "chevron-right" : "chevron-left";
    return dockedActive ? (<ExpanderContainer data-side-panel-expander={rightPanelExpanded ? "expanded" : "collapsed"} onClick={() => expanderOnClick()}>
      <IconButton color="#0000005e" tooltip={rightPanelExpanded ? "Collapse" : "Expand"} style={{ padding: "10px 3px", width: "inherit" }} type="font-awesome" size={18} disableFadeIn={true}>
        {iconName}
      </IconButton>
    </ExpanderContainer>) : null;
};
export default Expander;
